module.exports = __webpack_public_path__ + "img/bg-error.f0bee6d.svg";